import { render, staticRenderFns } from "./CustomGroupedSelectList.vue?vue&type=template&id=c93cb83c&scoped=true"
import script from "./CustomGroupedSelectList.vue?vue&type=script&lang=ts"
export * from "./CustomGroupedSelectList.vue?vue&type=script&lang=ts"
import style0 from "./CustomGroupedSelectList.vue?vue&type=style&index=0&id=c93cb83c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93cb83c",
  null
  
)

export default component.exports